import React from "react";
import { TabGroup } from "@headlessui/react";
import * as Styled from "./Tabs.styled";
interface TabsProps {
  tabs: {
    label: string;
    content: React.ReactNode;
  }[];
}
const Tabs: React.FC<TabsProps> = ({
  tabs
}) => {
  return <Styled.TabsContainer data-sentry-element="unknown" data-sentry-component="Tabs" data-sentry-source-file="index.tsx">
            <TabGroup data-sentry-element="TabGroup" data-sentry-source-file="index.tsx">
                <Styled.TabList data-sentry-element="unknown" data-sentry-source-file="index.tsx">
                    {tabs.map((tab, index) => <Styled.TabButton key={index}>
                            {tab.label}
                        </Styled.TabButton>)}
                </Styled.TabList>
                {tabs.map((tab, index) => <Styled.TabPanel key={index}>{tab.content}</Styled.TabPanel>)}
            </TabGroup>
        </Styled.TabsContainer>;
};
export default Tabs;